<template>
  <div class="slider-wrapper input-container highlight-box" @mouseenter="mouseEnter(name)" @mouseleave="mouseLeave(name)" :key="`stoSlider_${name}_tab_${tab}_current_${$store.state.calculatorData.currentPageNumber}`">
    <div class="row space-between">
      <div class="col-12 col-sm-7 spacebottom-to-sm">
          <span v-html="$t(`variablesNice.${name}`)"></span>
      </div>
      <div class="col-12 col-sm-5 d-md-none text-align-right spacebottom-to-sm">
        <!-- Mobile Input -->
        <input type="number" :min="min" :max="max" :value="$store.state.calculatorData.currentOrder[name]" :step="getSteps()" :disabled="disabled" class="slider-input" @input="updateInput" v-on:keyup="registerUserInput()" > mm
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">

        <div v-if="valueFix()">
          <div class="min-max-wraper">
            <span class="valueFix font-size-small">
              {{$tc(`globals.valueFix`, defaultValue, {defaultValue: calculatorDefault[name]()})}}
            </span>
          </div>
        </div>
        <div v-else>
          <vue-slider :ref="`slider_`+ name + `_tab_` + tab" :min="calculatorMin[name]()" :max="calculatorMax[name]()" v-show="show" v-model.number="$store.state.calculatorData.currentOrder[name]" :disabled="disabled" tooltip="false" class="slider" :interval="getSteps()"  @input="updateSlider" @click.native="registerUserInput('click2')"  ></vue-slider>
          <div class="min-max-wraper">
            <span v-if="min" class="min font-size-small"> min: {{min.toLocaleString()}}</span>
            <span v-else class="min font-size-small"> min: 0</span>
            <span v-if="(calculatorDefault[name]() > 0) && (name !== 'a') && (name !== 'b')" class="recommendation font-size-small" >
              {{$tc(`globals.recommendation`, defaultValue, {defaultValue: calculatorDefault[name]()})}}
            </span>
            <span class="max font-size-small">max: {{max.toLocaleString()}} </span>
          </div>
        </div>

      </div>
      <div class="col-md-4 d-none d-md-block">
        <!-- Desktop Input -->
        <input type="number" :min="min" :max="max" :value="$store.state.calculatorData.currentOrder[name]" :step="getSteps()" :disabled="disabled" class="slider-input" @input="updateInput" v-on:click="registerUserInput('click3')" v-on:keyup="registerUserInput('keyup3')" > mm
      </div>
      <div v-if="$store.state.calculatorData.errors[this.name] == 'min'" class="col-12 error">
        {{$tc(`globals.errorMin`, min, {min: min})}}
      </div>
      <div v-if="$store.state.calculatorData.errors[this.name] == 'max'" class="col-12 error">
        {{$tc(`globals.errorMax`, max, {max: max})}}
      </div>
      <div v-if="$store.state.calculatorData.errors[this.name] == 'steps'" class="col-12 error">
        {{$tc(`globals.errorSteps`, steps, {steps: getSteps()})}}
      </div>
      <div v-if="$store.state.calculatorData.errors[this.name] == 'd1BiggerThenC'" class="col-12 error">
        {{$t(`globals.d1BiggerC`)}}
      </div>
      <div v-if="$store.state.calculatorData.errors[this.name] == 'bIsNotCorrect' && (isBox)" class="col-12 error">
        {{$t(`elementWidths.elementWidthcalculationWarningBox`)}}
      </div>
      <div v-if="$store.state.calculatorData.errors[this.name] == 'bIsNotCorrect' && (!isBox)" class="col-12 error">
        {{$t(`elementWidths.elementWidthcalculationWarningNoBox`)}}
      </div>
      <div v-if="$store.state.calculatorData.errors[this.name] == 'gIsgraterThanW'" class="col-12 error">
        {{$t(`globals.gIsgraterThanW`)}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vueSlider from 'vue-slider-component'

export default {
  name: 'StoSlider',
  props: {
    name: String,
    tab: String,
    disabled: String
  },
  data () {
    return {
      min: 0,
      max: 0,
      steps: 0,
      defaultValue: 0,
      errorMsg: '',
      timeout: null,
      show: false
    }
  },
  computed: {
    ...mapGetters([
      'calculatorMin',
      'calculatorMax',
      'calculatorSteps',
      'calculatorDefault',
      'isBox'
    ])
  },
  components: {
    vueSlider
  },
  methods: {
    mouseEnter: (name) => {
      var list = document.getElementsByClassName('highlight-' + name)
      for (var i = 0; i < list.length; i++) {
        list[i].classList.add('active')
      }
    },
    mouseLeave: (name) => {
      var list = document.getElementsByClassName('highlight-' + name)
      for (var i = 0; i < list.length; i++) {
        list[i].classList.remove('active')
      }
    },
    updateInput: function (eventOrValue) {
      clearTimeout(this.timeout)
      let self = this
      this.timeout = setTimeout(function () {
        self.updateStore(self.name, parseInt(eventOrValue.target.value))
        self.tracking('Input', parseInt(eventOrValue.target.value))
        self.getErrorMessage(self.name)
      }, 2000)
    },
    updateSlider: function (eventOrValue) {
      clearTimeout(this.timeout)
      let self = this
      if ((this.$store.state.calculatorData.calculatorPages[this.$store.state.calculatorData.currentPageNumber].headline === this.tab) || (this.$store.state.calculatorData.currentPageNumber === 0)) {
        this.timeout = setTimeout(function () {
          self.updateStore(self.name, parseInt(eventOrValue))
          self.tracking('Slider', eventOrValue)
          self.getErrorMessage(self.name)
        }, 500)
      }
    },
    updateMinMax: function () {
      this.$nextTick(() => {
        if (this.$refs[`slider_` + this.name + `_tab_` + this.tab]) {
          this.$refs[`slider_` + this.name + `_tab_` + this.tab].setValue(this.$store.state.calculatorData.currentOrder[this.name])
          this.min = this.calculatorMin[this.name]()
          this.max = this.calculatorMax[this.name]()
        }
        this.show = true
      })
    },
    updateDefault: function () {
      this.$nextTick(() => {
        if (this.$refs[`slider_` + this.name + `_tab_` + this.tab]) {
          this.$refs[`slider_` + this.name + `_tab_` + this.tab].setValue(this.$store.state.calculatorData.currentOrder[this.name])
          this.defaultValue = this.calculatorDefault[this.name]()
        }
        this.show = true
      })
    },
    updateStore: function (key, value) {
      const payload = {
        key: key,
        value: value,
        validate: true
      }
      this.$store.dispatch('didInputFkt', payload)
    },
    getSteps: function () {
      this.steps = this.calculatorSteps[this.name]()
      return this.steps
    },
    valueFix: function () {
      let myForm = this.$store.state.calculatorData.currentOrder.elementForm
      if (myForm === 'jasa' || myForm === 'jaka') {
        if (this.name === 'a1' || this.name === 'a2') {
          this.disabled = 'disabled'
          return true
        }
      }
      return false
    },
    getErrorMessage: function (field) {
      if ((this.$store.state.calculatorData.errors[this.name] === 'min') && (this.name === field)) {
        this.trackErrorMessage(this.name, this.$tc(`globals.errorMin`, this.min, { min: this.min }))
      }

      if ((this.$store.state.calculatorData.errors[this.name] === 'max') && (this.name === field)) {
        this.trackErrorMessage(this.name, this.$tc(`globals.errorMax`, this.max, { max: this.max }))
      }

      if ((this.$store.state.calculatorData.errors[this.name] === 'steps') && (this.name === field)) {
        this.trackErrorMessage(this.name, this.$tc(`globals.errorSteps`, this.steps, { steps: this.getSteps() }))
      }

      if ((this.$store.state.calculatorData.errors[this.name] === 'd1BiggerThenC') && (this.name === field)) {
        this.trackErrorMessage(this.name, this.$t(`globals.d1BiggerC`))
      }

      if (this.$store.state.calculatorData.errors.d2) {
        this.trackingD2Errors()
      }

      if (this.$store.state.calculatorData.errors.w) {
        this.trackingWErrors()
      }

      // console.log(this)
      // if ((typeof this.$parent.trackingErrors() !== 'undefined') && (this.tab === 'elementHeights')) {
      //   this.registerUserInput()
      //   // this.$parent.trackingErrors()
      // }
    },
    trackErrorMessage: function (field, message) {
      if (this._i18n) {
        let gtmEvent = 'JKK-Events'
        let gtmEventCategory = this._i18n._vm.messages.de.variablesNiceGTM[this.name]
        let gtmEventAction = field
        let gtmEventLabel = message
        let virtualPageURL = '/' + this.$t(this.tab + '.virtualPageURL')
        let virtualPageTitle = this.$t(this.tab + '.virtualPageTitle')

        if ((typeof this.$root.$children['0'].currentPage !== 'undefined')) {
          this.$root.$children['0'].globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, '', virtualPageURL, virtualPageTitle)
        }

        if ((typeof this.$root.$children['0'].currentPage !== 'undefined')) {
          this.$root.$children['0'].globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, '', virtualPageURL, virtualPageTitle)
        }
      }
    },

    tracking: function (inputType, inputValue) {
      if (this._i18n) {
        let gtmEvent = 'JKK-Events'
        let gtmEventCategory = this._i18n._vm.messages.de.variablesNiceGTM[this.name]
        let gtmEventAction = inputType
        let gtmEventLabel = inputValue
        let gtmEventValue = inputValue
        let virtualPageURL = '/' + this.$t(this.tab + '.virtualPageURL')
        let virtualPageTitle = this.$t(this.tab + '.virtualPageTitle')

        if ((typeof this.$root.$children['0'].currentPage !== 'undefined')) {
          this.$root.$children['0'].globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, gtmEventValue, virtualPageURL, virtualPageTitle)
        }

        if ((typeof this.$root.$children['0'].currentPage !== 'undefined')) {
          this.$root.$children['0'].globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, gtmEventValue, virtualPageURL, virtualPageTitle)
        }
      }
    },

    trackingD2Errors: function () {
      if ((typeof this.$root.$children['0'].currentPage !== 'undefined')) {
        this.registerUserInput()
        let tabName = 'elementHeights'
        let gtmEvent = 'JKK-Events'
        let gtmEventCategory = 'Dämmkernhöhe D2'
        let gtmEventAction = 'Fehlerhafte Eingabe'
        let gtmEventLabel = 'Message'
        let gtmEventValue = ''
        let virtualPageURL = '/' + this.$tc(tabName + '.virtualPageURL')
        let virtualPageTitle = this.$tc(tabName + '.virtualPageTitle')
        if (this.$store.state.calculatorData.errors['d2'] === 'min') {
          gtmEventLabel = this.$tc(`elementHeights.d2errorMin`, this.$store.state.calculatorData.calculatorPages[3].inputFields[2].min, { min: this.calculatorMin.d2() })
        } else if (this.$store.state.calculatorData.errors['d2'] === 'max') {
          gtmEventLabel = this.$tc(`elementHeights.d2errorMax`, this.$store.state.calculatorData.calculatorPages[3].inputFields[2].max, { max: this.calculatorMax.d2() })
        } else if (this.$store.state.calculatorData.errors['d2'] === 'steps') {
          gtmEventLabel = this.$t('elementHeights.errorStep10')
        }
        this.$root.$children['0'].globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, gtmEventValue, virtualPageURL, virtualPageTitle)
      }
    },
    trackingWErrors: function () {
      if ((typeof this.$root.$children['0'].currentPage !== 'undefined')) {
        this.registerUserInput()
        let tabName = 'elementWidths'
        let gtmEvent = 'JKK-Events'
        let gtmEventCategory = 'Dicke der Wandseite W'
        let gtmEventAction = 'Fehlerhafte Eingabe'
        let gtmEventLabel = 'Message'
        let gtmEventValue = ''
        let virtualPageURL = '/' + this.$tc(tabName + '.virtualPageURL')
        let virtualPageTitle = this.$tc(tabName + '.virtualPageTitle')
        if (this.$store.state.calculatorData.errors['w'] === 'min') {
          gtmEventLabel = this.$tc(`elementHeights.werrorMin`, this.$store.state.calculatorData.calculatorPages[4].inputFields[2].min, { min: this.calculatorMin.w() })
        } else if (this.$store.state.calculatorData.errors['w'] === 'max') {
          gtmEventLabel = this.$tc(`elementHeights.werrorMax`, this.$store.state.calculatorData.calculatorPages[4].inputFields[2].max, { max: this.calculatorMax.w() })
        }
        this.$root.$children['0'].globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, gtmEventValue, virtualPageURL, virtualPageTitle)
      }
    },
    registerUserInput: function (item) {
      // this line needs to track only User Input
      this.$root.$children['0'].userDidAction = true
      this.$root.$children['0'].userDidAction = true
    }
  },
  watch: {
    'value': function (val, oldVal) {
      let myval = val

      if (val > this.max) {
        // myval = this.max
        this.errorMsg = 'Info: Der Wert darf maximal ' + this.max + ' sein.'
      } else if (val < this.min) {
        // myval = this.min
        this.errorMsg = 'Info: Der Wert muss mindestens ' + this.min + ' sein.'
      }
      this.value = Math.round(myval)
    },
    'show': function (val, oldVal) {
      if (val && !this.valueFix()) {
        const sliderName = `slider_${this.name}_tab_${this.tab}`
        if (this.$refs[sliderName]) {
          this.$nextTick(() => this.$refs[sliderName].refresh())
        }
      }
    }
  },
  mounted: function () {
    // console.log(this.show)
    // console.log('^')
    // console.log('--- StoSlider rendert ' + this.name + ' ---')
    this.show = false
    this.updateMinMax()
    this.updateDefault()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider-wrapper{
  cursor: pointer;
}

</style>
